import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';
import { useService } from 'shared/providers';
import { GetQuotesProps } from 'shared/services/quote-service';

export function useExportQuotesSummary(props: GetQuotesProps) {
  const { quoteService } = useService();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<boolean, Error>(() => quoteService.downloadQuotesSummary(props), {
    onSuccess: hasData => {
      if (!hasData) {
        enqueueSnackbar(`No quotes were found to export.`, {
          variant: 'warning',
        });
        return;
      }
      enqueueSnackbar(`Quotes have been exported`, {
        variant: 'success',
      });
    },
    onError: () => {
      enqueueSnackbar('There was a problem exporting quotes', { variant: 'error' });
    },
  });

  return mutation;
}
